import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/lib/theme";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  const submit = async () => {
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(e.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  const inp = { width: "100%", padding: "11px 14px", borderRadius: 8,
    border: `1px solid ${T.border}`, fontSize: 14, marginBottom: 14, outline: "none", color: T.navy };

  return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',system-ui,sans-serif", padding: 20 }} data-testid="forgot-page">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap')`}</style>
      <div style={{ background: "#fff", borderRadius: 16, padding: "40px 36px", maxWidth: 440, width: "100%", boxShadow: "0 4px 40px rgba(0,0,0,0.08)" }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: T.navy }}>WaveScore<span style={{ color: T.green }}>Pro</span></div>
          <div style={{ fontSize: 13, color: T.muted, marginTop: 4 }}>Reset your password</div>
        </div>
        {sent ? (
          <div data-testid="forgot-sent" style={{ textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
            <h2 style={{ color: T.navy, fontSize: 18, fontWeight: 700, marginBottom: 6 }}>Check your inbox</h2>
            <p style={{ color: T.muted, fontSize: 14, lineHeight: 1.6 }}>
              If <b>{email}</b> is registered, a password-reset link is on its way. The link expires in 30 minutes.
            </p>
            <button data-testid="forgot-back" onClick={() => nav("/login")}
              style={{ marginTop: 18, padding: "10px 22px", background: T.green, color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <p style={{ color: T.muted, fontSize: 13, marginBottom: 18, lineHeight: 1.6 }}>
              Enter the email tied to your WaveScorePro account. We'll send you a link to choose a new password.
            </p>
            <input data-testid="forgot-email" style={inp} type="email" placeholder="your@email.com"
              value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
            {error && <div data-testid="forgot-error" style={{ color: "#EF4444", fontSize: 13, marginBottom: 12 }}>⚠ {error}</div>}
            <button data-testid="forgot-submit" onClick={submit} disabled={loading || !email}
              style={{ width: "100%", padding: 12, borderRadius: 8, border: "none",
                background: loading ? "#9CA3AF" : T.green, color: "#fff", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Sending..." : "Send reset link"}
            </button>
            <p style={{ textAlign: "center", fontSize: 12, color: T.muted, marginTop: 16 }}>
              <span data-testid="forgot-signin-link" onClick={() => nav("/login")} style={{ color: T.green, cursor: "pointer", fontWeight: 600 }}>Back to sign in</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
